import { ApplicationUser } from "../entities/ApplicationUser";
import Coupon from "../entities/Coupon";
import { SubscriptionPlan } from "../entities/SubscriptionPlan";
import { WebClient } from "./server/WebClient";

const endpoint = "api/Subscription"

export interface CreateCheckoutSessionRequest {
    priceId: string;
    isAnnualPlan: boolean;
    couponId?: string;
    cancelPath: string;
}

export interface CreateBundleCheckoutSessionRequest {
    cancelPath: string;
}

export const SubscriptionService = {
    checkSubscriptionHistory: () => WebClient.Get<boolean>(`${endpoint}/CheckSubscriptionHistory`),
    hasUserHadFreeTrial: () => WebClient.Get<boolean>(`${endpoint}/FreeTrialStatus`),
    getPromoCode: (code:string) => WebClient.Get<Coupon |null>(`${endpoint}/PromoCode/${code}`),
    getActivePlans: () => WebClient.Get<SubscriptionPlan[]>(`${endpoint}/ActivePlans`),
    createCheckoutSession: (request: CreateCheckoutSessionRequest) => 
        WebClient.Post.Unvalidated<{sessionId: string}>(`${endpoint}/CreateCheckoutSession`, request),
    createBundleCheckoutSession: (request:CreateBundleCheckoutSessionRequest) => 
        WebClient.Post.Unvalidated<{sessionId: string}>(`${endpoint}/CreateBundleCheckout`, request),
    recordCheckout: (sessionId:string) => WebClient.Post.Validated<ApplicationUser | null>(`${endpoint}/RecordCheckout`, { sessionId })
}